import * as React from 'react';

import {Badge} from 'shells/badge/badge';
import {CloseIcon} from 'shells/icon/svg/close-icon';

import styles from './tiny-intro-company-logo.module.css';

type Props = {
    logoUrl: string;
    onRemove: () => void;
};

export function TinyIntroCompanyLogo(props: Props) {
    return (
        <div className={styles['company-logo']}>
            <img src={props.logoUrl} id='companyLogo' />
            <Badge
                contents={<CloseIcon size={8} fill='#fff' wrapWithDiv={false} />}
                onClick={props.onRemove}
                color='grey'
            />
        </div>
    );
}
